import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import Tooltip from '@mui/material/Tooltip';
import { makeStyles } from '@mui/styles';
import X from 'react-feather/dist/icons/x';
import NRConfirmationModalStyles from './NRConfirmationModal.styles';
import { CONSTANTS } from '../../constants/constants';
import Typography from '@mui/material/Typography';
const { CONFIRM, CANCEL, CLOSE_TOOLTIP } = CONSTANTS.CONFIRMATION_MODAL;
const useStyles = makeStyles(NRConfirmationModalStyles);
const { REMOVE, DELETE, DISABLE } = CONSTANTS.USER_ACTIONS;

function NRConfirmationModal({
  title,
  actionLabel = CONFIRM,
  cancelLabel = CANCEL,
  subtitle,
  content,
  open,
  handleClose,
  handleActionConfirm,
  handleCancel,
  modalWidth
}) {
  const classes = useStyles();

  const handleConfirm = () => {
    handleActionConfirm();
  };

  const body = (
    <div style={{ width: `${modalWidth}` }} className={classes.modalMainContainer}>
      <Card>
        <CardHeader
          classes={{ root: classes.cardHeader, title: classes.cardHeaderTitle }}
          title={title}
          subheader={subtitle}
          action={
            <Tooltip title={CLOSE_TOOLTIP} placement="right">
              <IconButton aria-label="Close" onClick={handleClose} size="large">
                <X />
              </IconButton>
            </Tooltip>
          }
        />
        <CardContent classes={{ root: classes.cardContent }}>{content}</CardContent>
        <CardActions classes={{ root: classes.cardActions, spacing: classes.cardActionsSpacing }}>
          <Button variant="outlined" color="secondary" onClick={handleCancel}>
            {cancelLabel}
          </Button>
          <Button variant="contained" color="secondary" onClick={handleConfirm}>
            {actionLabel}
          </Button>
        </CardActions>
      </Card>
    </div>
  );

  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
      {body}
    </Modal>
  );
}
export default NRConfirmationModal;
